import { Button, Dialog, Message, Spinner } from 'Components/Core';
import { actions } from 'Data/ReduxViewModels/Ags/ValidationError';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DownloadFileConfirmationDialog } from './DownloadFileConfirmationDialog';
import { ErrorMessageTable } from './ErrorMessageTable';
import './ValidationMessagesDialog.scss';
import { IDialogParams } from './types';

const ValidationMessagesDialog: React.FC<IDialogParams> = ({ dialogVisibleState, revisionId, onClose }) => {
  const dispatch = useDispatch();
  const ready = useSelector((state) => state.agsValidationErrorMessages.status?.ready);
  const errorMessage = useSelector((state) => state.agsValidationErrorMessages.status?.errorMessage);

  useEffect(() => {
    dialogVisibleState && dispatch(actions.init({ revisionId }));
  }, [dialogVisibleState, dispatch, revisionId]);

  // State for "Downloading File" Dialog
  const [confirmationDialogVisible, setConfirmationDialogVisible] = useState(false);

  // Function for closing this Dialog
  const closeMainDialog = () => {
    setConfirmationDialogVisible(false);
    onClose();
  };

  const dialogButtons = [
    <Button error onClick={() => setConfirmationDialogVisible(true)} disabled={!ready}>
      Download file with errors
    </Button>,
    <Button onClick={closeMainDialog}>Close</Button>,
  ];

  let dialogContent = <Spinner large />;
  if (ready && errorMessage) {
    dialogContent = <Message error>{errorMessage}</Message>;
  } else if (ready) {
    dialogContent = <ErrorMessageTable />;
  }

  return (
    <>
      <Dialog
        className="errorMessageDialog"
        onClose={closeMainDialog}
        visible={dialogVisibleState}
        width="75%"
        minHeight="200px"
        buttons={dialogButtons}
        title="Validation error messages"
      >
        {dialogContent}
      </Dialog>
      <DownloadFileConfirmationDialog
        dialogVisibleState={confirmationDialogVisible}
        onClose={setConfirmationDialogVisible}
        revisionId={revisionId}
      />
    </>
  );
};

export { ValidationMessagesDialog };
